var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingInactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 29,
    viewBox: "0 0 35 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2315 0.0398145L18.6709 1.76599L5.41709 6.91961L0.773719 5.11406L13.8239 0.0398145C13.9601 -0.0132715 14.0952 -0.0132715 14.2315 0.0398145ZM28.0552 14.8627C31.7829 14.8627 34.8047 17.8847 34.8047 21.6124C34.8047 25.3401 31.7829 28.362 28.0552 28.362C24.3276 28.362 21.3055 25.3401 21.3055 21.6124C21.3055 17.8847 24.3276 14.8627 28.0552 14.8627ZM30.6109 18.5344L26.6126 22.5326L25.2482 20.8155C24.9126 20.3934 24.2982 20.3232 23.876 20.6588C23.4537 20.9944 23.3835 21.6088 23.7192 22.031L25.7273 24.5578C26.0745 25.0552 26.7893 25.1232 27.222 24.6905L31.9944 19.918C32.3767 19.5359 32.3767 18.9165 31.9944 18.5344C31.6124 18.1523 30.993 18.1523 30.6109 18.5344ZM23.4113 3.60923C18.9934 5.32724 14.5756 7.04519 10.1574 8.76278L14.0276 10.2676L27.2815 5.11406L23.4113 3.60923ZM28.0552 6.01631L14.5901 11.252V26.8481L20.7143 24.4668C20.37 23.5818 20.1807 22.6193 20.1807 21.6124C20.1807 17.2634 23.7062 13.7379 28.0552 13.7379V6.01631ZM13.4651 26.848V11.252L9.38398 9.66517V12.9585C9.38398 13.1177 9.198 13.2036 9.07692 13.1004L6.91095 11.2556L4.88531 11.8856C4.76473 11.9231 4.64358 11.834 4.64358 11.7078V7.82193L0 6.01638V21.2275C0 21.4642 0.138164 21.6661 0.358875 21.7519L13.4651 26.848Z",
    fill: "#DC1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingInactiveIcon);
export default __webpack_public_path__ + "static/media/BookingInactiveIcon.f6e7449a5fe010cfd038119866a68e01.svg";
export { ForwardRef as ReactComponent };